// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"z6sogIL81UhUYUdZ"};